/******************/
/* Global js File */
/******************/
(function (app, $) {
    function checkCookie() {
        var cookieEnabled = navigator.cookieEnabled;
        if (!cookieEnabled) {
            document.cookie = "testcookie; path=/";
            cookieEnabled = document.cookie.indexOf("testcookie") != -1;
            document.cookie = "testcookie; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }
        return cookieEnabled || showCookieFail();
    }

    function showCookieFail() {
        $('body').append('<div class="alert alert-info alert-dismissible" role="alert" style="position: fixed; top: 0px; left: 0px;">'
            + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>'
            + app.resources.modelcookiedisabled
            + '</div >');
    }

    $(document).ready(function () {
        checkCookie();

        // navabar sticky
        $(window).scroll(function () {
            /* affix after scrolling 100px */
            if ($(document).scrollTop() > 440) {
                $('nav').addClass('fixed-top');
                $('#navFilters').addClass('d-block');
                $('body').addClass('menu-fixed');
            } else {
                $('nav').removeClass('fixed-top');
                $('#navFilters').removeClass('d-block');
                $('body').removeClass('menu-fixed');
            }
        });

        $('.top-scroller').on('click', function () {
            window.scrollTo(0, 0);
        });

        // readmore
        // Configure/customize these variables.
        var showChar = 300;  // How many characters are shown by default
        var showCharTitle = 70; //Goes with 1200px as support limit
        var ellipsestext = "...";

        $('.ellipsisTitle').each(function () {
            var content = $(this).html();

            if (content.length > showCharTitle) {

                var c = content.substr(0, showCharTitle);

                var html = '<span  title="' + content + '">' + c + '</span><span class="moreellipses">' + ellipsestext + '&nbsp;</span>';

                $(this).html(html);
            }
        });
        $('.ellipsisChar').each(function () {
            var content = $(this).html();

            if (content.length > showChar) {

                var c = content.substr(0, showChar);

                var html = c + '<span class="moreellipses">' + ellipsestext + '&nbsp;</span>';

                $(this).html(html);
            }
        });
        

        $('.form-contact').on('submit', function (e) {
            e.preventDefault();
            var $this = $(this);

            var emptyItem = $this.find('[required]:visible').filter(function () {
                return !this.value;
            });

            if (emptyItem.length > 0) {
                $this.closest('.modal').find('.form-error').removeClass('d-none');
                return false;
            }

            $('.form-error').addClass('d-none');

            $.post($this.attr('action'), $this.serialize())
                .done(function () {
                    $this.closest('.modal').modal('hide');
                })
                .fail(function (xhr, status, error) {
                    var errorText = xhr.responseJSON.Code === "10001" ? xhr.responseJSON.ConsoleMsg : app.resources.erroroccured;
                    $this.closest('.modal').find('.form-error').text(errorText).removeClass('d-none');
                    console.error('Send email contact error', status, error);
                });

            return false;
        });

        $('.alert-dismissible .close').on('click', function () {
            $(this).closest('.alert').addClass('d-none');
        });

        $(".toggle-password").on('click', function () {
            var $this = $(this);
            $this.toggleClass("fa-eye fa-eye-slash");
            var input = $this.prev();
            if (input.attr("type") == "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });

        $('.logo-link').on('click', function (e) {
            e.preventDefault();
            $.ajax({
                url: app.routes.home.resetSearch,
                type: 'GET',
                cache: false
            })
                .done(function () {
                    window.location = app.routes.home.index;
                });
        });

        //event manipulation
        $('.form-submit').on('click', function () {
            var target = $(this).data('form-target');
            if (target) {
                console.log(target);
                $(target).trigger('submit');
            }
        }); 

        $('.stop_propagation').on('click', function (e) {
            e.stopPropagation();
            return false;
        });

        $('#language_selector a').on('click', function (e) {
            e.preventDefault();
            $.ajax({
                url: this.href,
                type: 'GET',
                cache: false
            })
                .done(function () {
                    window.location.reload();
                });

            return false;
        });
    });
})(window.app = window.app || {}, jQuery);